import React from 'react'
import styled from 'styled-components'
import ClubLead from './ClubLead'
const About = () => {

    return (
        <>
		
             <ClubLead  />
                
            
         
        </>
    );

}

export default About;

const Heading = styled.div`
    font-size : 80px;
    color : green;
`

const Wrap = styled.div `
    
    background-color: whitesmoke;
	color:black;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
	padding-top: 15vh;
	text-align: center;
`
// import React from "react";

// const About = () =>{
//   return (
//     <>
//     <div className="mt-8 flex w-full flex-col items-center text-gray-700">
//       <h2 className="mb-6 text-gray-100">Club Leads</h2>
//       {/* <div className="flex w-full items-start justify-evenly">
//         {clubLeads.map((clubLead) => (
//           <ClubLead key={clubLead.name} clubLead={clubLead} />
//         ))}
//       </div> */}
//     </div>
//     </>
//   );
// }

// export default About;